import { SingleValueCookie } from 'saddlebag-cookie';

import { clearPreferencesCookie } from './clearPreferencesCookie';

export const getTrackIdentifier = () => {
  clearPreferencesCookie();
  return Promise.resolve(
    new SingleValueCookie('traveller_context').getValue(),
  ).then((utid) => ({
    utid,
  }));
};
